<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <main class="main-content position-relative border-radius-lg ">
      <!-- Navbar -->
      <HeaderMenu></HeaderMenu>
      <!-- End Navbar -->
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <div v-for="(notification, index) in notifications" :key="index" class="alert position-fixed top-0 end-0 m-3"
             :class="notification.class" role="alert" style="color: white; z-index: 9999; max-width: 360px;">
          {{ notification.message }}
          <button style="font-size: small" type="button" class="btn-close" @click="closeNotification(index)"
                  aria-label="Close"></button>
        </div>
        <div class="modal fade" id="modalLogAccesos" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div v-if="cargando" class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Cargando...</span>
                </div>
              </div>
              <div v-else>
                <div class="container">
                  <div class="table-responsive">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Registro</th>
                          <th>Usuario</th>
                          <th>Fecha y hora</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="acceso in registrosAcceso" :key="acceso.id">
                          <td>Acceso a la aplicación</td>
                          <td>{{ acceso.username }} - {{ acceso.email }}</td>
                          <td>{{ formatearFecha(acceso.logged_in_at) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <nav aria-label="Page navigation" v-if="totalRecords > pageLength">
                    <ul class="pagination justify-content-center">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-arrow-left"></i></button>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><i class="fa-solid fa-arrow-right"></i></button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <div class="card mb-4">
              <div class="card-header pb-0 d-flex">
                <h6>Usuarios</h6>
                <button class="btn btn-primary btn-sm ms-auto d-none"  data-bs-toggle="modal" data-bs-target="#modalLogAccesos" @click="abrirModalLogAccesos">Ver Accesos</button>
                <button @click="nuevoUsuario" class="btn btn-primary btn-sm ms-auto">Nuevo</button>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <div class="px-3 py-3 d-flex gap-2 align-items-center">
                  <input type="text" class="form-control" placeholder="Buscar usuario, nombre o email..." v-model="searchUsuario" style="max-width: 360px; min-height: 38px;">
                </div>
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Nombre</th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Email</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="usuario in usuariosPaginados" v-bind:key="usuario.id" @click="usuarioSeleccionado=normalizarUsuario(usuario)">
                      <td class="align-middle text-start">
                        <span class="text-secondary text-xs font-weight-bold">{{ usuario.username }}</span>
                      </td>
                      <td class="align-middle text-start">
                        <span class="text-secondary text-xs font-weight-bold">{{ usuario.name }}</span>
                      </td>
                      <td class="align-middle text-start">
                        <span class="text-secondary text-xs font-weight-bold">{{ usuario.email }}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <nav aria-label="Page navigation" v-if="totalUsuarios > pageLengthUsuarios">
                  <ul class="pagination justify-content-center">
                    <li class="page-item" :class="{ disabled: currentPageUsuarios === 1 }">
                      <button class="page-link" @click="changePageUsuarios(currentPageUsuarios - 1)" :disabled="currentPageUsuarios === 1"><i class="fa-solid fa-arrow-left"></i></button>
                    </li>
                    <li class="page-item" v-for="page in paginationRangeUsuarios" :key="'up_' + page">
                      <button class="page-link" @click="changePageUsuarios(page)"
                              :style="{ backgroundColor: page === currentPageUsuarios ? 'black' : '', color: page === currentPageUsuarios ? 'white' : '' }">{{ page }}</button>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPageUsuarios === totalPagesUsuarios }">
                      <button class="page-link" @click="changePageUsuarios(currentPageUsuarios + 1)" :disabled="currentPageUsuarios === totalPagesUsuarios"><i class="fa-solid fa-arrow-right"></i></button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          <div class="col-7">
            <div class="container-fluid">
              <div class="card">
                <div class="card-header pb-0">
                  <div class="d-flex align-items-center">
                    <p class="mb-0 text-uppercase">Datos usuario</p>
                    <div class="ms-auto d-flex gap-2">
                      <button @click="guardarUsuario" class="btn btn-primary btn-sm">Guardar</button>
                      <button 
                        v-if="usuarioSeleccionado.id" 
                        @click="mostrarModalEliminar = true" 
                        class="btn btn-danger btn-sm">
                        Eliminar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="form-control-label">Usuario</label>
                        <input class="form-control" style="min-height: 45px" type="text" v-model="usuarioSeleccionado.username">
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label class="form-control-label">Nombre</label>
                        <input class="form-control" style="min-height: 45px" type="text" v-model="usuarioSeleccionado.name">
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label class="form-control-label">Email</label>
                        <input class="form-control" style="min-height: 45px" type="text" v-model="usuarioSeleccionado.email">
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-check mt-4">
                        <input class="form-check-input" type="checkbox" v-model="usuarioSeleccionado.is_admin">
                        <label class="form-check-label" >
                          Administrador
                        </label>
                      </div>
                      
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="form-control-label">Cambiar Contraseña</label>
                        <input class="form-control" style="min-height: 45px" type="password" v-model="usuarioSeleccionado.password1">
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="form-control-label">Confirmar Contraseña</label>
                        <input class="form-control" style="min-height: 45px" type="password" v-model="usuarioSeleccionado.password2">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card mt-4">
                <div class="card-header pb-0">
                  <div class="d-flex align-items-center justify-content-between">
                    <p class="mb-0 text-uppercase">Esquemas Permitidos</p>
                    <div class="d-flex gap-2">
                      <button 
                        v-if="!permisosCopiados || permisosCopiados.usuarioId !== usuarioSeleccionado.id"
                        @click="copiarPermisos" 
                        class="btn btn-sm btn-outline-primary"
                        :disabled="!usuarioSeleccionado.id"
                        title="Copiar permisos de este usuario"
                      >
                        <i class="fas fa-copy me-1"></i>Copiar permisos
                      </button>
                      <button 
                        v-if="permisosCopiados && permisosCopiados.usuarioId !== usuarioSeleccionado.id"
                        @click="pegarPermisos" 
                        class="btn btn-sm btn-outline-success"
                        :disabled="!usuarioSeleccionado.id"
                        title="Pegar permisos copiados"
                      >
                        <i class="fas fa-paste me-1"></i>Pegar permisos
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row esquemas-row">
                    <div class="esquema-section" v-for="(esquema, index) in esquemas" :key="index">
                      <div class="esquema-titulo mb-2">
                        <div class="esquema-icono" :style="{ backgroundColor: esquema.color }">
                          <i :class="esquema.icono" style="font-size: large;color: white"></i>
                        </div>
                        <div class="esquema-nombre">{{esquema.grupo}} - {{esquema.nombre}}</div>
                        <button class="btn btn-outline-primary px-0 py-1 my-0" 
                        style="min-width: 30px !important; max-width: 30px !important;" 
                        title="Editar permisos" @click="abrirModalPermisos(esquema)">
                          <i class="fa-solid fa-plus"></i>
                        </button>
                      </div>
                      <div class="form-check align-items-center mt-2">
                        <input class="form-check-input" type="checkbox"
                               :checked="(usuarioSeleccionado.esquemasVisualizables || []).includes(esquema.id)"
                               @change="(e) => {
                                  if (!usuarioSeleccionado.esquemasVisualizables) {
                                    usuarioSeleccionado.esquemasVisualizables = [];
                                  }
                                  const checked = e.target.checked;
                                  const index = usuarioSeleccionado.esquemasVisualizables.indexOf(esquema.id);
                                  if (checked && index === -1) {
                                    usuarioSeleccionado.esquemasVisualizables.push(esquema.id);
                                  } else if (!checked && index !== -1) {
                                    usuarioSeleccionado.esquemasVisualizables.splice(index, 1);
                                  }
                                }">
                        <label class="form-check-label mt-1" style="font-size: 0.95em;">Visualización</label>
                      </div>
                      <div class="form-check align-items-center mt-2">
                        <input class="form-check-input" type="checkbox"
                               :checked="(usuarioSeleccionado.esquemasEditables || []).includes(esquema.id)"
                               @change="(e) => {
                                  if (!usuarioSeleccionado.esquemasEditables) {
                                    usuarioSeleccionado.esquemasEditables = [];
                                  }
                                  const checked = e.target.checked;
                                  const index = usuarioSeleccionado.esquemasEditables.indexOf(esquema.id);
                                  if (checked && index === -1) {
                                    usuarioSeleccionado.esquemasEditables.push(esquema.id);
                                  } else if (!checked && index !== -1) {
                                    usuarioSeleccionado.esquemasEditables.splice(index, 1);
                                  }
                                }">
                        <label class="form-check-label mt-1" style="font-size: 0.95em;">Editar</label>
                      </div>
                      <div class="form-check align-items-center mt-2">
                        <input class="form-check-input" type="checkbox"
                               :checked="(usuarioSeleccionado.esquemasBorrables || []).includes(esquema.id)"
                               @change="(e) => {
                                  if (!usuarioSeleccionado.esquemasBorrables) {
                                    usuarioSeleccionado.esquemasBorrables = [];
                                  }
                                  const checked = e.target.checked;
                                  const index = usuarioSeleccionado.esquemasBorrables.indexOf(esquema.id);
                                  if (checked && index === -1) {
                                    usuarioSeleccionado.esquemasBorrables.push(esquema.id);
                                  } else if (!checked && index !== -1) {
                                    usuarioSeleccionado.esquemasBorrables.splice(index, 1);
                                  }
                                }">
                        <label class="form-check-label mt-1" style="font-size: 0.95em;">Borrar</label>
                      </div>
                      <div class="form-check align-items-center mt-2">
                        <input class="form-check-input" type="checkbox"
                               :checked="(usuarioSeleccionado.esquemasAdjuntables || []).includes(esquema.id)"
                               @change="(e) => {
                                  if (!usuarioSeleccionado.esquemasAdjuntables) {
                                    usuarioSeleccionado.esquemasAdjuntables = [];
                                  }
                                  const checked = e.target.checked;
                                  const index = usuarioSeleccionado.esquemasAdjuntables.indexOf(esquema.id);
                                  if (checked && index === -1) {
                                    usuarioSeleccionado.esquemasAdjuntables.push(esquema.id);
                                  } else if (!checked && index !== -1) {
                                    usuarioSeleccionado.esquemasAdjuntables.splice(index, 1);
                                  }
                                }">
                        <label class="form-check-label mt-1" style="font-size: 0.95em;">Adjuntar</label>
                      </div>
                      <div v-if="features.aprobacion_documentos_disponible && esquema.requiere_aprobacion" class="form-check align-items-center mt-2">
                        <input class="form-check-input" type="checkbox"
                               :checked="(usuarioSeleccionado.esquemasAprobables || []).includes(esquema.id)"
                               @change="(e) => {
                                  if (!usuarioSeleccionado.esquemasAprobables) {
                                    usuarioSeleccionado.esquemasAprobables = [];
                                  }
                                  const checked = e.target.checked;
                                  const index = usuarioSeleccionado.esquemasAprobables.indexOf(esquema.id);
                                  if (checked && index === -1) {
                                    usuarioSeleccionado.esquemasAprobables.push(esquema.id);
                                  } else if (!checked && index !== -1) {
                                    usuarioSeleccionado.esquemasAprobables.splice(index, 1);
                                  }
                                }">
                        <label class="form-check-label mt-1" style="font-size: 0.95em;">Aprobar</label>
                      </div>
                      <div v-if="features.caducidad_documentos_disponible && esquema.tiene_caducidad" class="form-check align-items-center mt-2">
                        <input class="form-check-input" type="checkbox"
                               :checked="(usuarioSeleccionado.esquemasRevisarCaducidad || []).includes(esquema.id)"
                               @change="(e) => {
                                  if (!usuarioSeleccionado.esquemasRevisarCaducidad) {
                                    usuarioSeleccionado.esquemasRevisarCaducidad = [];
                                  }
                                  const checked = e.target.checked;
                                  const index = usuarioSeleccionado.esquemasRevisarCaducidad.indexOf(esquema.id);
                                  if (checked && index === -1) {
                                    usuarioSeleccionado.esquemasRevisarCaducidad.push(esquema.id);
                                  } else if (!checked && index !== -1) {
                                    usuarioSeleccionado.esquemasRevisarCaducidad.splice(index, 1);
                                  }
                                }">
                        <label class="form-check-label mt-1" style="font-size: 0.95em;">Revisar Caducidad</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal Confirmación Eliminar Usuario -->
        <div v-if="mostrarModalEliminar" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.3);">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Confirmar eliminación</h5>
                <button type="button" class="btn-close" @click="mostrarModalEliminar = false"></button>
              </div>
              <div class="modal-body">
                <p>¿Estás seguro de que deseas eliminar al usuario <strong>{{ usuarioSeleccionado.username }}</strong>?</p>
                <p class="text-danger mb-0">Esta acción no se puede deshacer.</p>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" @click="mostrarModalEliminar = false">Cancelar</button>
                <button class="btn btn-danger" @click="eliminarUsuario">Eliminar</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Permisos por Esquema -->
        <div v-if="mostrarModalPermisos" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.3);">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title d-flex align-items-center" style="gap: 8px;">
                  <span class="esquema-icono" :style="{ backgroundColor: esquemaSeleccionadoPermiso?.color }">
                    <i :class="esquemaSeleccionadoPermiso?.icono" style="color: white;"></i>
                  </span>
                  <span class="esquema-nombre">{{ esquemaSeleccionadoPermiso?.grupo }} - {{ esquemaSeleccionadoPermiso?.nombre }}</span>
                </h5>
                <button type="button" class="btn-close" @click="cancelarPermisos"></button>
              </div>
              <div class="modal-body">
                <div class="row g-3 mb-3">
                  <div class="col-12 d-flex flex-wrap gap-4">
                    <label class="form-check d-flex align-items-center gap-2">
                      <input class="form-check-input" type="checkbox" v-model="permisosEdit.visualizar">
                      <span>Visualización</span>
                    </label>
                    <label class="form-check d-flex align-items-center gap-2">
                      <input class="form-check-input" type="checkbox" v-model="permisosEdit.editar">
                      <span>Edición</span>
                    </label>
                    <label class="form-check d-flex align-items-center gap-2">
                      <input class="form-check-input" type="checkbox" v-model="permisosEdit.borrar">
                      <span>Borrado</span>
                    </label>
                    <label class="form-check d-flex align-items-center gap-2">
                      <input class="form-check-input" type="checkbox" v-model="permisosEdit.adjuntar">
                      <span>Adjuntos</span>
                    </label>
                    <label v-if="features.aprobacion_documentos_disponible && esquemaSeleccionadoPermiso?.requiere_aprobacion" class="form-check d-flex align-items-center gap-2">
                      <input class="form-check-input" type="checkbox" v-model="permisosEdit.aprobar">
                      <span>Aprobar</span>
                    </label>
                    <label v-if="features.caducidad_documentos_disponible && esquemaSeleccionadoPermiso?.tiene_caducidad" class="form-check d-flex align-items-center gap-2">
                      <input class="form-check-input" type="checkbox" v-model="permisosEdit.revisarCaducidad">
                      <span>Revisar Caducidad</span>
                    </label>
                  </div>
                </div>
                <!-- Cargando -->
                <div v-if="modalCargando" class="d-flex justify-content-center align-items-center my-3">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                  </div>
                </div>

                <!-- Propiedades del esquema -->
                <div v-else class="mt-2">
                  <div v-for="prop in propiedadesEsquema" :key="prop.id" class="mb-3">
                    <label class="form-control-label">{{ prop.descripcion || prop.nombre }}</label>
                    <div class="tag-input-container form-control d-flex flex-wrap align-items-center gap-2">
                      <span
                        v-for="(t, ti) in getTags(prop.campoBD)"
                        :key="t + '-' + ti"
                        class="badge bg-primary d-flex align-items-center gap-1"
                      >
                        <span>{{ t }}</span>
                        <span
                          class="tag-close ms-1"
                          role="button"
                          tabindex="0"
                          @pointerdown.prevent.stop="removeTagByValue(prop.campoBD, t)"
                          @keydown.enter.prevent.stop="removeTagByValue(prop.campoBD, t)"
                          @keydown.space.prevent.stop="removeTagByValue(prop.campoBD, t)"
                        >
                          <i class="fa-solid fa-xmark"></i>
                        </span>
                      </span>
                      <input
                        type="text"
                        class="tag-input-field flex-grow-1 border-0"
                        v-model="propiedadesInputTemporal[prop.campoBD]"
                        @keydown="onTagInputKeyDown(prop.campoBD, $event)"
                        @blur="onTagInputBlur(prop.campoBD)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" @click="cancelarPermisos">Cancelar</button>
                <button class="btn btn-primary" @click="guardarPermisos">Guardar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

  </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu.vue";
import {onMounted, ref, reactive, computed, watch} from "vue";
import axiosInstance from "@/axios";

export default {
  name: "UsuariosView",
  components: {HeaderMenu},
  setup() {
    const usuarios = ref([]);
    const searchUsuario = ref('');
    const pageLengthUsuarios = ref(10);
    const currentPageUsuarios = ref(1);
    const esquemas = ref([]);
    const features = ref({
      aprobacion_documentos_disponible: false,
      caducidad_documentos_disponible: false
    });
    const usuarioSeleccionado = ref({id:'',name:'',username:'',email:'',password1:'',password2:'',is_admin:false,
      esquemasVisualizables:[],
      esquemasEditables:[],
      esquemasBorrables:[],
      esquemasAdjuntables:[],
      esquemasAprobables:[],
      esquemasRevisarCaducidad:[]
    });
    const notifications = ref([]);
    const permisosCopiados = ref(null); // Almacena los permisos copiados: { usuarioId, permisos }

    // Función para cerrar una notificación
    const closeNotification = (index) => {
      notifications.value.splice(index, 1);
    };

    // Función para normalizar usuario y asegurar que todos los arrays de permisos existan
    const normalizarUsuario = (usuario) => {
      if (!usuario) return usuario;
      return {
        ...usuario,
        is_admin: usuario.is_admin === true || usuario.is_admin === 1 || usuario.is_admin === '1',
        esquemasVisualizables: Array.isArray(usuario.esquemasVisualizables) ? usuario.esquemasVisualizables : [],
        esquemasEditables: Array.isArray(usuario.esquemasEditables) ? usuario.esquemasEditables : [],
        esquemasBorrables: Array.isArray(usuario.esquemasBorrables) ? usuario.esquemasBorrables : [],
        esquemasAdjuntables: Array.isArray(usuario.esquemasAdjuntables) ? usuario.esquemasAdjuntables : [],
        esquemasAprobables: Array.isArray(usuario.esquemasAprobables) ? usuario.esquemasAprobables : [],
        esquemasRevisarCaducidad: Array.isArray(usuario.esquemasRevisarCaducidad) ? usuario.esquemasRevisarCaducidad : []
      };
    };

    onMounted(async () => {
      try {
        const response = await axiosInstance.get("/api/usuarios");
        usuarios.value = (response.data.users || []).map(normalizarUsuario);
        if (usuarios.value.length > 0) {
          usuarioSeleccionado.value = normalizarUsuario(usuarios.value[0]);
        }
        // Cargar esquemas completos y features desde el endpoint de esquemas
        try {
          const esquemasResponse = await axiosInstance.get("/api/esquemas");
          if (esquemasResponse.data.esquemas && Array.isArray(esquemasResponse.data.esquemas)) {
            esquemas.value = esquemasResponse.data.esquemas;
          } else if (Array.isArray(esquemasResponse.data)) {
            esquemas.value = esquemasResponse.data;
          }
          if (esquemasResponse.data.features) {
            features.value = {
              aprobacion_documentos_disponible: esquemasResponse.data.features.aprobacion_documentos_disponible ?? false,
              caducidad_documentos_disponible: esquemasResponse.data.features.caducidad_documentos_disponible ?? false
            };
          }
        } catch (error) {
          console.error("Error al obtener esquemas y features", error);
          // Fallback: usar esquemas del endpoint de usuarios si falla
          if (response.data.esquemas) {
            esquemas.value = response.data.esquemas;
          }
        }
      } catch (error) {
        console.error("Error al obtener los usuarios", error);
      }
    });

    const usuariosFiltrados = computed(() => {
      const term = (searchUsuario.value || '').toLowerCase().trim();
      if (!term) return usuarios.value || [];
      return (usuarios.value || []).filter(u =>
        String(u.username || '').toLowerCase().includes(term) ||
        String(u.name || '').toLowerCase().includes(term) ||
        String(u.email || '').toLowerCase().includes(term)
      );
    });

    const totalUsuarios = computed(() => usuariosFiltrados.value.length);
    const totalPagesUsuarios = computed(() => Math.max(1, Math.ceil(totalUsuarios.value / pageLengthUsuarios.value)));
    const paginationRangeUsuarios = computed(() => {
      const range = [];
      const delta = 2;
      const start = Math.max(1, currentPageUsuarios.value - delta);
      const end = Math.min(totalPagesUsuarios.value, currentPageUsuarios.value + delta);
      for (let i = start; i <= end; i++) range.push(i);
      return range;
    });

    const usuariosPaginados = computed(() => {
      const start = (currentPageUsuarios.value - 1) * pageLengthUsuarios.value;
      const end = start + pageLengthUsuarios.value;
      return usuariosFiltrados.value.slice(start, end);
    });

    watch([searchUsuario], () => {
      currentPageUsuarios.value = 1;
    });

    const changePageUsuarios = (page) => {
      if (page >= 1 && page <= totalPagesUsuarios.value) {
        currentPageUsuarios.value = page;
      }
    };

    const showNotification = (message, type) => {
      const notification = {
        message,
        class: type,
      };
      notifications.value.push(notification);

      // Cerrar la notificación automáticamente después de 2 segundos
      setTimeout(() => {
        closeNotification(notifications.value.indexOf(notification));
      }, 2000); // 2000 milisegundos = 2 segundos
    };

    // Estado modal de eliminación
    const mostrarModalEliminar = ref(false);

    // Estado modal de permisos por esquema
    const mostrarModalPermisos = ref(false);
    const esquemaSeleccionadoPermiso = ref(null);
    const permisosEdit = reactive({ visualizar: false, editar: false, borrar: false, adjuntar: false, aprobar: false, revisarCaducidad: false });
    const modalCargando = ref(false);
    const propiedadesEsquema = ref([]);
    const propiedadesValores = reactive({});
    const propiedadesInputTemporal = reactive({});

    const abrirModalPermisos = (esquema) => {
      esquemaSeleccionadoPermiso.value = esquema;
      const id = esquema.id;
      permisosEdit.visualizar = (usuarioSeleccionado.value.esquemasVisualizables || []).includes(id);
      permisosEdit.editar = (usuarioSeleccionado.value.esquemasEditables || []).includes(id);
      permisosEdit.borrar = (usuarioSeleccionado.value.esquemasBorrables || []).includes(id);
      permisosEdit.adjuntar = (usuarioSeleccionado.value.esquemasAdjuntables || []).includes(id);
      permisosEdit.aprobar = (usuarioSeleccionado.value.esquemasAprobables || []).includes(id);
      permisosEdit.revisarCaducidad = (usuarioSeleccionado.value.esquemasRevisarCaducidad || []).includes(id);
      mostrarModalPermisos.value = true;
      // Cargar propiedades del esquema
      cargarPropiedadesEsquema(id);
    };

    const cancelarPermisos = () => {
      mostrarModalPermisos.value = false;
      esquemaSeleccionadoPermiso.value = null;
      propiedadesEsquema.value = [];
      Object.keys(propiedadesValores).forEach(k => delete propiedadesValores[k]);
      Object.keys(propiedadesInputTemporal).forEach(k => delete propiedadesInputTemporal[k]);
      modalCargando.value = false;
    };

    const toggleIdInArray = (arr, id, enable) => {
      const idx = arr.indexOf(id);
      if (enable && idx === -1) arr.push(id);
      if (!enable && idx !== -1) arr.splice(idx, 1);
    };

    const cargarPropiedadesEsquema = async (id) => {
      modalCargando.value = true;
      propiedadesEsquema.value = [];
      Object.keys(propiedadesValores).forEach(k => delete propiedadesValores[k]);
      try {
        const response = await axiosInstance.get(`/api/datospermisosesquema/${id}/${usuarioSeleccionado.value.id}`);
        const props = response.data?.esquema?.propiedades || [];
        propiedadesEsquema.value = props;
        // Inicializar valores
        props.forEach(p => {
          if (p && p.campoBD) propiedadesValores[p.campoBD] = p.filtro;
          if (p && p.campoBD) propiedadesInputTemporal[p.campoBD] = '';
        });
      } catch (e) {
        showNotification('Error al cargar propiedades del esquema', 'alert-danger');
      } finally {
        modalCargando.value = false;
      }
    };

    const normalizeToTags = (value) => {
      if (!value) return [];
      return String(value)
        .split(';')
        .map(s => s.trim())
        .filter(Boolean);
    };

    const tagsToString = (tags) => {
      return tags.join(';');
    };

    const getTags = (campoBD) => {
      return normalizeToTags(propiedadesValores[campoBD]);
    };

    const addTag = (campoBD, newTag) => {
      const trimmed = (newTag || '').trim();
      if (!trimmed) return;
      const current = normalizeToTags(propiedadesValores[campoBD]);
      if (!current.includes(trimmed)) {
        current.push(trimmed);
        propiedadesValores[campoBD] = tagsToString(current);
      }
      propiedadesInputTemporal[campoBD] = '';
    };

    const removeTag = (campoBD, index) => {
      const current = normalizeToTags(propiedadesValores[campoBD]);
      if (index >= 0 && index < current.length) {
        current.splice(index, 1);
        propiedadesValores[campoBD] = tagsToString(current);
      }
    };

    const removeTagByValue = (campoBD, value) => {
      const current = normalizeToTags(propiedadesValores[campoBD]);
      const idx = current.indexOf(String(value));
      if (idx !== -1) {
        current.splice(idx, 1);
        propiedadesValores[campoBD] = tagsToString(current);
      }
    };

    const onTagInputKeyDown = (campoBD, event) => {
      if (event.key === 'Enter' || event.key === ';') {
        event.preventDefault();
        addTag(campoBD, propiedadesInputTemporal[campoBD]);
      }
      if (event.key === 'Backspace' && !propiedadesInputTemporal[campoBD]) {
        const current = normalizeToTags(propiedadesValores[campoBD]);
        if (current.length > 0) {
          // Editar el último tag rápidamente
          propiedadesInputTemporal[campoBD] = current.pop();
          propiedadesValores[campoBD] = tagsToString(current);
        }
      }
    };

    const onTagInputBlur = (campoBD) => {
      if (propiedadesInputTemporal[campoBD]) {
        addTag(campoBD, propiedadesInputTemporal[campoBD]);
      }
    };

    const guardarPermisos = async () => {
      if (!esquemaSeleccionadoPermiso.value) return;
      const id = esquemaSeleccionadoPermiso.value.id;
      // Actualizar arrays locales de permisos por esquema
      toggleIdInArray(usuarioSeleccionado.value.esquemasVisualizables, id, permisosEdit.visualizar);
      toggleIdInArray(usuarioSeleccionado.value.esquemasEditables, id, permisosEdit.editar);
      toggleIdInArray(usuarioSeleccionado.value.esquemasBorrables, id, permisosEdit.borrar);
      toggleIdInArray(usuarioSeleccionado.value.esquemasAdjuntables, id, permisosEdit.adjuntar);
      toggleIdInArray(usuarioSeleccionado.value.esquemasAprobables, id, permisosEdit.aprobar);
      toggleIdInArray(usuarioSeleccionado.value.esquemasRevisarCaducidad, id, permisosEdit.revisarCaducidad);

      // Preparar payload de filtros: { filtros: { [prop.id]: valor } }
      const filtros = {};
      try {
        modalCargando.value = true;
        propiedadesEsquema.value.forEach((prop) => {
          if (!prop) return;
          const keyCampo = prop.campoBD;
          const valor = keyCampo ? propiedadesValores[keyCampo] : undefined;
          filtros[String(prop.id)] = valor ?? '';
        });

        await axiosInstance.post(`/api/filtrospropiedad/${id}/${usuarioSeleccionado.value.id}`, { filtros :filtros });

        mostrarModalPermisos.value = false;
        showNotification('Permisos y filtros guardados.', 'alert-success');
      } catch (e) {
        showNotification('Error al guardar filtros de propiedades', 'alert-danger');
      } finally {
        modalCargando.value = false;
      }
      // Si en el futuro hay que persistir los arrays de permisos, se puede hacer aquí
      // await axiosInstance.post('/api/actualizarPermisosUsuario', { usuario: usuarioSeleccionado.value });
    };

    const guardarUsuario = async () => {
      try {
        const response = await axiosInstance.post("/api/user", {usuario: usuarioSeleccionado.value});
        usuarios.value = (response.data.usuarios || []).map(normalizarUsuario);
        usuarioSeleccionado.value = normalizarUsuario(response.data.usuarioSeleccionado);
        showNotification('Usuario guardado.', 'alert-success');

      } catch (error) {
        const mensaje = error.response.data || 'Error al guardar el usuario.';
        showNotification(mensaje, 'alert-danger');
      }
    };

    const nuevoUsuario = () => {
      usuarioSeleccionado.value = {id:'',name:'',username:'',email:'',password1:'',password2:'',is_admin:false,
      esquemasVisualizables:[],
      esquemasEditables:[],
      esquemasBorrables:[],
      esquemasAdjuntables:[],
      esquemasAprobables:[],
      esquemasRevisarCaducidad:[]}
    };

    const copiarPermisos = () => {
      if (!usuarioSeleccionado.value.id) {
        showNotification('No hay usuario seleccionado para copiar permisos.', 'alert-warning');
        return;
      }

      permisosCopiados.value = {
        usuarioId: usuarioSeleccionado.value.id,
        usuarioNombre: usuarioSeleccionado.value.name || usuarioSeleccionado.value.username,
        permisos: {
          esquemasVisualizables: [...(usuarioSeleccionado.value.esquemasVisualizables || [])],
          esquemasEditables: [...(usuarioSeleccionado.value.esquemasEditables || [])],
          esquemasBorrables: [...(usuarioSeleccionado.value.esquemasBorrables || [])],
          esquemasAdjuntables: [...(usuarioSeleccionado.value.esquemasAdjuntables || [])],
          esquemasAprobables: [...(usuarioSeleccionado.value.esquemasAprobables || [])],
          esquemasRevisarCaducidad: [...(usuarioSeleccionado.value.esquemasRevisarCaducidad || [])]
        }
      };

      showNotification(`Permisos básicos copiados del usuario "${permisosCopiados.value.usuarioNombre}". Nota: Solo se copian los permisos básicos (Visualización, Editar, Borrar, Adjuntar, Aprobar, Revisar Caducidad), no los permisos avanzados.`, 'alert-info');
    };

    const pegarPermisos = () => {
      if (!permisosCopiados.value) {
        showNotification('No hay permisos copiados para pegar.', 'alert-warning');
        return;
      }

      if (!usuarioSeleccionado.value.id) {
        showNotification('No hay usuario seleccionado para pegar permisos.', 'alert-warning');
        return;
      }

      if (permisosCopiados.value.usuarioId === usuarioSeleccionado.value.id) {
        showNotification('No puedes pegar permisos del mismo usuario.', 'alert-warning');
        return;
      }

      // Aplicar los permisos copiados
      usuarioSeleccionado.value.esquemasVisualizables = [...permisosCopiados.value.permisos.esquemasVisualizables];
      usuarioSeleccionado.value.esquemasEditables = [...permisosCopiados.value.permisos.esquemasEditables];
      usuarioSeleccionado.value.esquemasBorrables = [...permisosCopiados.value.permisos.esquemasBorrables];
      usuarioSeleccionado.value.esquemasAdjuntables = [...permisosCopiados.value.permisos.esquemasAdjuntables];
      usuarioSeleccionado.value.esquemasAprobables = [...permisosCopiados.value.permisos.esquemasAprobables];
      usuarioSeleccionado.value.esquemasRevisarCaducidad = [...permisosCopiados.value.permisos.esquemasRevisarCaducidad];

      showNotification(`Permisos pegados desde "${permisosCopiados.value.usuarioNombre}"`, 'alert-success');
    };

    const eliminarUsuario = async () => {
      if (!usuarioSeleccionado.value.id) {
        showNotification('No hay usuario seleccionado para eliminar.', 'alert-danger');
        return;
      }

      try {
        await axiosInstance.delete(`/api/user/${usuarioSeleccionado.value.id}`);
        
        // Recargar la lista de usuarios
        const response = await axiosInstance.get("/api/usuarios");
        usuarios.value = (response.data.users || []).map(normalizarUsuario);
        
        // Seleccionar el primer usuario si hay alguno, sino crear uno nuevo
        if (usuarios.value.length > 0) {
          usuarioSeleccionado.value = normalizarUsuario(usuarios.value[0]);
        } else {
          nuevoUsuario();
        }
        
        mostrarModalEliminar.value = false;
        showNotification('Usuario eliminado correctamente.', 'alert-success');
      } catch (error) {
        console.error("Error al eliminar el usuario", error);
        const mensaje = error.response?.data?.message || error.response?.data || 'Error al eliminar el usuario.';
        showNotification(mensaje, 'alert-danger');
      }
    };


    const mostrarModalLogAccesos = ref(false);

    // Función para abrir el modal
    const abrirModalLogAccesos = () => {

      //TODO peticion a log accesos
      mostrarModalLogAccesos.value = true;
      fetchData();
    };

    // Función para cerrar el modal
    const cerrarModalLogAccesos = () => {
      mostrarModalLogAccesos.value = false;
    };

// Estado de los datos de la tabla y los filtros
    const registrosAcceso = ref([]);
    const searchFilters = reactive({});
    // Paginación
    const pageLength = ref(10);
    const currentPage = ref(1);
    const totalRecords = ref(0);
    const cargando = ref(false);

    const totalPages = computed(() => Math.ceil(totalRecords.value / pageLength.value));
    const paginationRange = computed(() => {
      const range = [];
      const delta = 2; // Número de páginas antes y después de la actual
      const start = Math.max(1, currentPage.value - delta);
      const end = Math.min(totalPages.value, currentPage.value + delta);
      for (let i = start; i <= end; i++) range.push(i);
      return range;
    });

    const changePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
        fetchData();
      }
    };

    // Función para obtener los datos del backend
    const fetchData = async () => {
      cargando.value = true; // Activar el spinner
      try {
        const params = {
          start: (currentPage.value - 1) * pageLength.value,
          length: pageLength.value,
          draw: Date.now()
        };

        const response = await axiosInstance.post("/api/registrosLog", {params});
        registrosAcceso.value = response.data.data;
        totalRecords.value = response.data.recordsTotal;
      } catch (error) {
        console.error("Error fetching data", error);
        showNotification("Error al obtener los datos", 'alert-danger');
      } finally {
        cargando.value = false; // Desactivar el spinner
      }
    };

    // Cuando cambian los filtros, actualizar la tabla
    //watch(searchFilters, fetchData, {deep: true});
    watch(pageLength, fetchData);

    // Formatea fecha de 'yyyy-mm-dd H:i:s' a 'd/m/yyyy HH:ii:ss'
    function formatearFecha(fechaStr) {
      if (!fechaStr) return '';
      const [fecha, hora] = fechaStr.split(' ');
      if (!fecha || !hora) return fechaStr;
      const [y, m, d] = fecha.split('-');
      return `${d}/${m}/${y} ${hora}`;
    }

    return {
      usuarios,
      // buscador/paginación usuarios
      searchUsuario,
      pageLengthUsuarios,
      currentPageUsuarios,
      usuariosPaginados,
      paginationRangeUsuarios,
      changePageUsuarios,
      totalUsuarios,
      totalPagesUsuarios,
      esquemas,
      features,
      usuarioSeleccionado,
      normalizarUsuario,
      guardarUsuario,
      notifications,
      closeNotification,
      nuevoUsuario,
      eliminarUsuario,
      permisosCopiados,
      copiarPermisos,
      pegarPermisos,
      mostrarModalEliminar,
      mostrarModalLogAccesos,
      abrirModalLogAccesos,
      cerrarModalLogAccesos,
      cargando,
      registrosAcceso,
      searchFilters,
      paginationRange,
      changePage,
      formatearFecha,
      totalRecords,
      pageLength,
      currentPage,
      // modal permisos
      mostrarModalPermisos,
      permisosEdit,
      esquemaSeleccionadoPermiso,
      abrirModalPermisos,
      cancelarPermisos,
      guardarPermisos,
      modalCargando,
      propiedadesEsquema,
      propiedadesValores,
      propiedadesInputTemporal,
      onTagInputKeyDown,
      onTagInputBlur,
      removeTag,
      removeTagByValue,
      getTags
    };
  },
}
</script>

<style scoped>
/* Personalización adicional del estilo */

.list-group-item {
  border-radius: 0.375rem;
  padding: 10px 15px;
}

.list-group-item:hover {
  background-color: #f8f9fa;
}

.btn-sm {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
}

.ms-2 {
  margin-left: 0.5rem;
}

button {
  min-width: 75px;
  text-align: center;
}

.esquemas-row {
  gap: 18px 18px;
}

.esquema-section {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  margin-bottom: 18px;
  margin-top: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  padding: 12px 8px;
  transition: box-shadow 0.2s;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-right: 12px;
  width: 22%;
}

.esquema-titulo {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  gap: 0.5rem;
  margin-bottom: 0;
}

.esquema-icono {
  display: grid;
  justify-content: center;
  align-items: center;
  min-width: 36px;
  height: 36px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.esquema-icono i {
  font-size: large;
  color: white;
}

.esquema-nombre {
  font-size: 0.75rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #344767;
  margin-left: 0.25rem;
}

.form-check-label.mt-1 {
  font-size: 0.95em;
}

.tag-input-container {
  min-height: 45px;
  padding: 6px 8px;
}

.tag-input-field:focus {
  outline: none;
  box-shadow: none;
}

.badge.bg-primary {
  background: #5e72e4 !important;
  border-radius: 12px;
  padding: 6px 10px;
}

.tag-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  color: rgba(255,255,255,0.9);
  transition: background-color 0.15s ease, color 0.15s ease;
  cursor: pointer;
}

.tag-close:hover {
  background-color: rgba(255,255,255,0.15);
}

.tag-close i {
  font-size: 0.7rem;
  line-height: 1;
}
</style>

<style scoped>
/* Estilo para paginación redonda */
.pagination .page-item .page-link {
  border-radius: 50% !important;
  width: 38px !important;
  height: 38px !important;
  min-width: 38px !important;
  min-height: 38px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  margin: 0 4px !important;
}
</style>